import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EditUserComponent } from './edit-user.component';
import { EditUserResolve } from './edit-user.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/user/edit/:id',
        component: EditUserComponent,
        resolve: {
          users: EditUserResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class EditUserRoutingModule {}
